import { Injectable } from '@angular/core'
import { IModelBase } from 'common-components'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IState extends IModelBase {
  Abbreviation: string
  Name: string
  CountryId: number
}

@Injectable()
export class PayerStateODataService extends ODataService<IState> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'PayerStates'
  }
}

@Injectable()
export class ProviderStateODataService extends ODataService<IState> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ProviderStates'
  }
}
